module.exports = __webpack_public_path__ + "static/media/expand_more_24_px.a2835dd9.svg";